const Marionette = require('backbone.marionette');
const templates = require('../templates');
const BookingView = require('./main_booking.js');
const app = require('../app.js');

const DayView = Marionette.CollectionView.extend({
  className: 'activity_list',
  tagName: 'ul',
  // collection view options
  childView: BookingView,
  emptyView: Marionette.ItemView.extend({
    template: '<li>&nbsp;</li>'
  })
});

const HourView = Marionette.CompositeView.extend({
  className: 'planning_part',
  template: templates.main_hour,
  serializeModel() {
    return {
      hour: this.model
    };
  },
  // collection view options
  childView: DayView,
  childViewContainer: '.right_pp',
  childViewOptions(model) {
    return {
      collection: model.get('bookings')
    };
  }
});

const SectionView = Marionette.CompositeView.extend({
  className: 'planning_block',
  tagName: 'section',
  template: templates.main_section,
  serializeModel() {
    return {
      section: this.model
    };
  },
  // collection view options
  childView: HourView,
  childViewContainer: '.planning_parts',
  childViewOptions(model) {
    return {
      model,
      collection: model.get('days')
    };
  }
});

module.exports = Marionette.CollectionView.extend({
  initialize() {
    this.listenTo(app.vent, 'returnToDefault', this.returnToDefault);
  },
  className: 'content',
  // collection view options
  childView: SectionView,
  childViewOptions(model) {
    return {
      model,
      collection: model.get('hours')
    };
  },
  returnToDefault() {
    app.vent.trigger('closeActivityPopup');
    app.vent.trigger('scrollToCurrentBlock');
    app.vent.trigger('animateOverflowBookings');
  }
});



// WEBPACK FOOTER //
// ./src/views/main.js